import { Show } from 'solid-js'

const ReactivationAdminModal = (props: {
  show: boolean
  onClose: () => void
  onConfirm: () => void
  loading?: boolean
}) => {
  const handleBackgroundClick = (event: MouseEvent) => {
    if (event.target === event.currentTarget) {
      props.onClose()
    }
  }

  return (
    <Show when={props.show}>
      <div
        class="fixed inset-0 z-[200] flex items-center justify-center bg-black/80"
        onClick={handleBackgroundClick}
      >
        <div class="relative mx-2 w-full max-w-[560px] rounded-xl bg-gradient-to-r from-cosplay-purple to-cosplay-blue-200 p-[2px] md:mx-4">
          <div class="relative h-full w-full overflow-hidden rounded-lg bg-[#0B0F11]">
            <button
              onClick={props.onClose}
              class="absolute right-5 top-4 z-10 text-2xl text-white hover:text-white md:right-6 md:top-6 md:text-gray-400"
            >
              ✕
            </button>

            <div class="p-6">
              <h2 class="mb-6 text-2xl font-semibold">Manual Subscription Reactivation</h2>

              <div class="flex flex-col gap-4">
                <div class="flex items-center gap-2 text-orange-500">
                  <i class="fas fa-exclamation-triangle" />
                  <span class="font-bold">CAUTION!</span>
                </div>

                <p class="text-gray-200">
                  Are you sure you want to activate this subscription? This will:
                </p>
                <ul class="ml-6 list-disc text-gray-200">
                  <li>Bypass Epoch payment processing as an admin user</li>
                  <li>Not charge the customer</li>
                  <li>Only be used for failed payments or manual reactivation cases</li>
                </ul>

                <div class="mt-4 flex justify-end gap-3">
                  <button
                    class="rounded-lg px-4 py-2 text-gray-300 hover:text-white"
                    onClick={props.onClose}
                  >
                    Cancel
                  </button>
                  <button
                    class="flex items-center gap-2 rounded-lg bg-cosplay-red px-4 py-2 text-white hover:bg-cosplay-red/90 disabled:opacity-50"
                    onClick={props.onConfirm}
                    disabled={props.loading}
                  >
                    {props.loading ? (
                      <>
                        <div class="h-4 w-4 animate-spin rounded-full border-2 border-white border-t-transparent" />
                        Reactivating...
                      </>
                    ) : (
                      'Yes, Reactivate Subscription'
                    )}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Show>
  )
}

export default ReactivationAdminModal
